/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Idnes_SubtitleInputs */

const cs_idnes_subtitle = /** @type {(inputs: Idnes_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import MAFRA (FTP + HTTP). Preferujte testovací endpoint a dry-run do úspěšného sandboxu.`)
};

const en_idnes_subtitle = /** @type {(inputs: Idnes_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MAFRA import (FTP + HTTP). Prefer test endpoint and dry-run until sandbox proof.`)
};

/**
* | output |
* | --- |
* | "MAFRA import (FTP + HTTP). Prefer test endpoint and dry-run until sandbox proof." |
*
* @param {Idnes_SubtitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const idnes_subtitle = /** @type {((inputs?: Idnes_SubtitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Idnes_SubtitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_idnes_subtitle(inputs)
	return cs_idnes_subtitle(inputs)
});